<template>
  <!--begin::Modal - Create account-->
  <div
    class="modal fade"
    id="kt_register_account_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog mw-1000px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Title-->
          <h2>Register with SEALPRO</h2>
          <!--end::Title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body scroll-y m-5">
          <!--begin::Stepper-->
          <div
            ref="createAccountRef"
            class="stepper stepper-links d-flex flex-column"
            id="kt_create_account_stepper"
          >
            <!--begin::Nav-->
            <div class="stepper-nav py-5">
              <!--begin::Step 1-->
              <div class="stepper-item current" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                 Account Info
                </h3>
              </div>
              <!--end::Step 1-->

              <!--begin::Step 3-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Insurance Info
                </h3>
              </div>
              <!--end::Step 3-->

              <!--begin::Step 2-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Activation Info
                </h3>
              </div>
              <!--end::Step 2-->

              <!--begin::Step 2-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Confirmation
                </h3>
              </div>
              <!--end::Step 2-->


              <!--begin::Step 5-->
              <div class="stepper-item" data-kt-stepper-element="nav">
                <h3 class="stepper-title">
                  Completed
                </h3>
              </div>
              <!--end::Step 5-->
            </div>
            <!--end::Nav-->

            <!--begin::Form-->
            <form
              class="mx-auto mw-600px w-100 py-10"
              novalidate="novalidate"
              id="kt_create_account_form"
              @submit="handleStep"
            >


              <!--begin::Step 1-->
              <div class="current" data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title--> 
                    <!--end::Title-->

                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                      Please fill-up all the information correctly. 
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <div class="row mb-10">
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">First Name</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title="Your First Name"
                          ></i>
                        </label>
                        <!--end::Label-->

                        

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_firstName"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_firstName" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->

  
                      </div>
                      <!--end::Input group-->
                    </div> 

                    <div class="col-md-6 fv-row"> 
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label
                            class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                          >
                            <span  >Middle Name</span>
                             
                          </label>
                          <!--end::Label-->

                          <Field
                            type="text"
                            class="form-control form-control-solid"
                            placeholder=""
                            name="insured_middleName"
                            maxlength="50"
                          />
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="insured_middleName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Last Name</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_lastName"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_lastName" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Birth Date</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="date"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_birthday"
                              format="DD/MM/yyyy"
                              
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_birthday" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  
                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Country of Nationality</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                            name="address_country2" 
                            v-model="address_country2"
                            class="form-select form-select-lg form-select-solid"
                            as="select"
                          >
                          <!-- {{countries}} -->
                          <option
                                v-for="i in countries"
                                :key="i"
                                :label="i.name"
                                :value="i.country_id"
                              >
                              </option>

                          </Field>
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_country2" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Job Classification</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                            name="job_classification" 
                            v-model="job_classification"
                            class="form-select form-select-lg form-select-solid"
                            as="select"
                          >
                          
                            <!-- {{job_classification_options_list}} -->
                          <option
                                v-for="i in job_classification_options_list"
                                :key="i"
                                :label="i.name"
                                :value="i.job_classification_id"
                              >
                              </option>

                          </Field>
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="job_classification" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>

                  </div>

                  <!--begin::Input group-->
                  <div class="row mb-10">
                    <!--begin::Col-->
                    <div class="col-md-12 fv-row">
                      <!--begin::Label-->
                      <label class="required fs-6 fw-bold form-label mb-2"
                        >Account Access</label
                      >
                      <!--end::Label-->

                      <!--begin::Row-->
                      <div class="row fv-row">
                        <!--begin::Col-->
                        <div class="col-12">
                          <Field
                            name="username"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Username"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="username" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="password"
                            class="form-control form-control-solid"
                            type="password"
                            placeholder="Password"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="password" />
                            </div>
                          </div>
                          <div class="fs-7 fw-bold text-gray-400">
                            Password
                          </div>
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="cpassword"
                            class="form-control form-control-solid"
                            type="password"
                            placeholder="Confirm Password"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="cpassword" />
                            </div>
                          </div>
                          <div class="fs-7 fw-bold text-gray-400">
                            Confirm Password
                          </div>
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!--end::Col-->
 
                  </div>
                  <!--end::Input group-->

                  <!--begin::Input group-->
                  <div class="row mb-10">
                    <!--begin::Col-->
                    <div class="col-md-12 fv-row">
                      <!--begin::Label-->
                      <label class="required fs-6 fw-bold form-label mb-2"
                        >Sponsor Info</label
                      >
                      <!--end::Label-->

                      <!--begin::Row-->
                      <div class="row fv-row">
                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="sponsorid"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Sponsor ID"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="sponsorid" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          <Field
                            name="uplineid"
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Upline ID"
                            :readonly="isDisabledUPID"
                          /> 
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="uplineid" />
                            </div>
                          </div> 
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-6">
                          
                          <Field
                            name="position"
                            class="form-select form-select-lg form-select-solid"
                            as="select"
                            :disabled="isDisabledUPID"
                          >
                            <option>Select Position</option>
                            <option label="Left" value="L">Left</option>
                            <option label="Right" value="R">Right</option>
                          </Field>

                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="position" />
                            </div>
                          </div> 
                          <div class="fs-7 fw-bold text-gray-400">
                            Position
                          </div>
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!--end::Col-->
 
                  </div>
                  <!--end::Input group-->
                  
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 1-->


              <!--begin::Step 1-->
              <div data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title--> 
                    <!--end::Title-->

                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                      Below are the details for your Insurance coverage
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  <div class="row mb-10">
                    

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Mobile Number</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_mobileNumber" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_mobileNumber" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>   

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Email</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="insured_email" 
                              @keydown.space.prevent
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="insured_email" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>   


                  <div class="pb-3 pb-lg-5">
                    <!--begin::Title--> 
                    <!--end::Title-->

                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                       Your address
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Block Number and Street</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="address_blockAndStreet" 
                              maxlength="100"
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_blockAndStreet" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>   

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="fs-6 fw-bold form-label mb-2"
                            >Name of Building(Optional)</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="address_nameOfBuilding" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_nameOfBuilding" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class=" fs-6 fw-bold form-label mb-2"
                            >Unit Number (Optional)</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="address_unitNumber" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_unitNumber" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >City</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="address_city" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_city" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class=" fs-6 fw-bold form-label mb-2"
                            >Postal Code</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="address_postalCode" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_postalCode" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Country</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                            name="address_country" 
                            v-model="address_country"
                            class="form-select form-select-lg form-select-solid"
                            as="select"
                            @change="getCities(address_country)"
                          >
                          {{countries}}
                          <option
                                v-for="i in countries"
                                :key="i"
                                :label="i.name"
                                :value="i.country_id"
                              >
                              </option>

                          </Field>
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_country" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Province</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                            name="address_province"
                            class="form-select form-select-lg form-select-solid"
                            as="select" 
                          >
                          <option
                                v-for="i in cities"
                                :key="i"
                                :label="i.name"
                                :value="i.zone_id"
                              >
                              </option>

                          </Field>
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="address_province" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>


                  </div>


                  <div class="pb-3 pb-lg-5">
                    <!--begin::Title--> 
                    <!--end::Title-->

                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                        Beneficiary Details
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
                  
                  
                  <div class="row mb-10">
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">Beneficiary First Name</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title="Beneficiary First Name"
                          ></i>
                        </label>
                        <!--end::Label-->

                        <Field
                          type="text"
                          class="form-control form-control-solid"
                          placeholder=""
                          name="beneficiary_firstName"
                          maxlength="50" 
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="beneficiary_firstName" />
                          </div>
                        </div>
                      </div>
                      <!--end::Input group-->
                    </div> 

                    <div class="col-md-6 fv-row"> 
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label
                            class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                          >
                            <span class="required">Beneficiary Middle Name</span>
                            <i
                              class="fas fa-exclamation-circle ms-2 fs-7"
                              data-bs-toggle="tooltip"
                              title="Beneficiary Middle Name"
                            ></i>
                          </label>
                          <!--end::Label-->

                          <Field
                            type="text"
                            class="form-control form-control-solid"
                            placeholder=""
                            name="beneficiary_middleName"
                            maxlength="50" 
                          />
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="beneficiary_middleName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Beneficiary Last Name</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="beneficiary_lastName" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="beneficiary_lastName" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Beneficiary Birth Date</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="date"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="beneficiary_birthday" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="beneficiary_birthday" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>  

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Beneficiary Mobile Number</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            <Field
                              type="text"
                              class="form-control form-control-solid"
                              placeholder=""
                              name="beneficiary_contact" 
                            />
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="beneficiary_contact" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div>   

                    <div class="col-md-6 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Relationship With Insured</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            <!--begin::Input-->
                            
                          <Field
                            name="beneficiary_relationship"
                            class="form-select form-select-lg form-select-solid"
                            as="select"
                          > 
                            <option>Select Relationship</option>
                            <option label="Spouse" value="Spouse">Spouse</option>
                            <option label="Child" value="Child">Child</option>
                            <option label="Parent" value="Parent">Parent</option>
                            <option label="Sibling" value="Sibling">Sibling</option>
                            <option label="Others (Blood-related, Relative)" value="Others">Others (Blood-related, Relative)</option>
                          </Field>
                            <div class="fv-plugins-message-container">
                              <div class="fv-help-block">
                                <ErrorMessage name="beneficiary_relationship" />
                              </div>
                            </div>
                            <!--end::Input-->
                            
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div> 

                    

                    <div class="col-md-12 fv-row">
                        <!--begin::Input group-->
                        <div class="d-flex flex-column mb-7 fv-row">
                          <!--begin::Label-->
                          <label class="required fs-6 fw-bold form-label mb-2"
                            >Terms and Conditions</label
                          >
                          <!--end::Label-->

                          <!--begin::Input wrapper-->
                          <div class="position-relative">
                            
                            <p>By activating the code, you are confirming that you have taken the time to read, comprehend, and review the terms and conditions outlined in the linked insurance policy and that you hereby acknowledge that you understood, and agreed to the terms and conditions of the said insurance policy including the general exclusions, claim requirements, and other sections of the policy.</p>
                            <p>By activating the code, you also confirm that the personal information that you submitted are true and correct of your own knowledge. </p>
                            <p>By activating the code, you hereby authorize Orbix Victus International Inc. & Stronghold Insurance Company Inc. to collect and store your data. Data such as but not limited to, your full name, nationality, mobile number, and other relevant information, using electronic or automated means, shall be stored within the period allowed under applicable laws, rules and regulations, for the purpose of processing your insurance policy.</p>
                            
                            <div class="row mb-5 mt-5">
                                <label class="form-check-label col-md-10">
                                <input class="form-check-input" id="checkbox4" type="checkbox" v-on:click="checkBoxValidator($event);">
                                <span class="form-check-sign"></span>
                                I have read the Terms and Conditions. I agree and I want to proceed!
                                </label>

                            </div>
                          </div>
                          <!--end::Input wrapper-->
                        </div>
                        <!--end::Input group-->
                    </div> 


                  </div>
 


                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 1-->

              <!--begin::Step 1-->
              <div   data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  <!--begin::Heading-->
                  <div class="pb-10 pb-lg-15">
                    <!--begin::Title-->
                    <h2 class="fw-bolder d-flex align-items-center text-dark">
                      Enter Activation code
                      <i
                        class="fas fa-exclamation-circle ms-2 fs-7"
                        data-bs-toggle="tooltip" 
                      ></i>
                    </h2>
                    <!--end::Title-->
     
                    <!--begin::Notice-->
                    <div class="text-gray-400 fw-bold fs-6">
                      Activation code can be found in the scratch card inside your package 
                    </div>
                    <!--end::Notice-->
                  </div>
                  <!--end::Heading-->
 
 
                  <div class="row mb-10">
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">User ID</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title=""
                          ></i>
                        </label>
                        <!--end::Label-->

                        <Field
                          type="text"
                          class="form-control form-control-solid"
                          placeholder=""
                          name="userid"
                          maxlength="20" 
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="userid" />
                          </div>
                        </div>
                      </div>
                      <!--end::Input group-->
                    </div> 
                    <div class="col-md-6 fv-row"> 
                      <!--begin::Input group-->
                      <div class="d-flex flex-column mb-7 fv-row">
                        <!--begin::Label-->
                        <label
                          class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                        >
                          <span class="required">PIN</span>
                          <i
                            class="fas fa-exclamation-circle ms-2 fs-7"
                            data-bs-toggle="tooltip"
                            title=""
                          ></i>
                        </label>
                        <!--end::Label-->

                        <Field
                          type="text"
                          class="form-control form-control-solid"
                          placeholder=""
                          name="securitypin"
                          maxlength="20" 
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="securitypin" />
                          </div>
                        </div>
                      </div>
                      <!--end::Input group-->
                    </div> 

                    
                   </div> 
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 1-->
 




              <!--begin::Step 5-->
              <div data-kt-stepper-element="content">
                <!--begin::Wrapper-->
                <div class="w-100">
                  

                  <!--begin::Body-->
                  <div class="mb-0">
                    

                    <!--begin::Alert-->
                    <div
                      class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
                      v-if="formData.verifyingdata"
                    >
                      <!--begin::Icon-->
                      <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
                        <inline-svg
                          src="media/icons/duotone/Code/Warning-1-circle.svg"
                        />
                      </span>
                      <!--end::Icon-->
                      <!--begin::Wrapper-->
                      <div class="d-flex flex-stack flex-grow-1">
                        <!--begin::Content-->
                        <div class="fw-bold" >
                          <h4 class="text-gray-800 fw-bolder">
                            Please wait... verifying data...
                          </h4>
                          <div class="fs-6 text-gray-600">
                            <a href="javascript:;" class="fw-bolder"></a>
                          </div>
                        </div>
                        <!--end::Content-->
                      </div>
                      <!--end::Wrapper-->
                    </div>
                    <!--end::Alert-->

                    <ConfirmRegister :formdata="formData" v-if="formData.verifyingdata === false"></ConfirmRegister>



                  </div>
                  <!--end::Body-->
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Step 5-->





                <!--begin::Step 5-->
                <div data-kt-stepper-element="content">
                  <div class="w-100 text-center">
                    <!--begin::Heading-->
                    <h1 class="fw-bolder text-dark mb-3"></h1>
                    <!--end::Heading-->

                    <!--begin::Description-->
                    <div class="text-muted fw-bold fs-3">
                      Submitting your application. Please wait
                    </div>
                    <!--end::Description-->

                    <!--begin::Illustration-->
                    <div class="text-center px-4 py-15">
                      <img
                        src="media/illustrations/todo.png"
                        alt=""
                        class="mw-100 mh-150px"
                      />
                    </div>
                    <!--end::Illustration-->
                  </div>
                </div>
                <!--end::Step 5-->


              <!--begin::Actions-->
              <div class="d-flex flex-stack pt-15">
                <!--begin::Wrapper-->
                <div class="me-2">
                  <button
                    type="button"
                    class="btn btn-lg btn-light-primary me-3"
                    data-kt-stepper-action="previous"
                    @click="previousStep()"
                  >
                    <span class="svg-icon svg-icon-3 me-1">
                      <inline-svg
                        src="media/icons/duotone/Navigation/Left-2.svg"
                      />
                    </span>
                    Back
                  </button>
                </div>
                <!--end::Wrapper-->

                <!--begin::Wrapper-->
                <div v-if="formData.verifyingdata === false && currentStepIndex !== (totalSteps -1)">
                  <button
                    type="submit"
                    class="btn btn-lg btn-primary"
                    v-if="currentStepIndex === totalSteps - 2"
                    @click="formSubmit()"
                  >
                    <span class="indicator-label">
                      Submit
                      <span class="svg-icon svg-icon-3 ms-2 me-0">
                        <inline-svg
                          src="icons/duotone/Navigation/Right-2.svg"
                        />
                      </span>
                    </span>
                    <span class="indicator-progress">
                      Please wait...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </button>
                  
                  <button type="submit" class="btn btn-lg btn-primary" v-if="(currentStepIndex == 1 && formData.istncchecked == true) || currentStepIndex != 1 && currentStepIndex != 3">
                    Continue
                    <span class="svg-icon svg-icon-3 ms-1 me-0">
                      <inline-svg
                        src="media/icons/duotone/Navigation/Right-2.svg"
                      />
                    </span>
                  </button>
                </div>
                <!--end::Wrapper-->
              </div>
              <!--end::Actions-->
            </form>
            <!--end::Form-->
          </div>
          <!--end::Stepper-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - Create project-->
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";

import {getcountries, getcities, getjobclassifications}  from "@/api/common";
import { confirm_register, save_register}  from "@/api/register";


import ConfirmRegister from "@/views/auth/ConfirmRegister.vue";

interface Step1 { 
  insured_firstName: string;
  insured_middleName: string;
  insured_lastName: string;
  insured_birthday: string;
  username: string;
  password: string;
  cpassword: string;
  sponsorid: string;
  uplineid: string;
  position: string;
}

interface Step2 { 
  

  insured_mobileNumber: string;
  insured_email: string;  
  address_blockAndStreet: string;
  address_nameOfBuilding: string;
  address_unitNumber:  string;
  address_city:  string;
  address_postalCode:  string;
  address_country:  string;
  address_country2: string;
  job_classification:string;
  address_province:  string; 
  beneficiary_firstName: string;
  beneficiary_middleName: string;
  beneficiary_lastName: string;
  beneficiary_birthday: string;
  beneficiary_contact: string;
  beneficiary_relationship: string; 
  istncchecked : boolean;
}

interface Step3 {
  userid: string;
  securitypin: string;
  verifyingdata: boolean; 
  country_text: string;
  country_text2: string;
  job_classification_text: string;
  province_text: string;
  responsedata: object;
}

interface Step4 {
}

interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "create-account-modal",
  data() {
    return {   
        address_country: "",
        address_country2:"",
        job_classification:"",
        confirm_data: {},
        show_parent_consent : false,
        showContinueButton : false,
        istncchecked : false
    }
  },
  components: {
    Field,
    ErrorMessage,
    ConfirmRegister
  },
  props: { 
        slotdata: Object
  },
  setup(props, context) {
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAccountRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);

    const countries = ref([]) as any; 
    const cities = ref([]) as any; 
    const job_classification_options_list = ref([]) as any; 

    const getJobClassifications =  async () => { 
      job_classification_options_list.value = [];
        const response = await getjobclassifications(); 
        if(response.data !== undefined && response.data.list !== undefined) {
          job_classification_options_list.value = response.data.list; 
        }
    }; 

    const httpGetCountries =  async () => { 
      countries.value = [];
        const response = await getcountries(); 
        if(response.data !== undefined && response.data.countries !== undefined) {
          countries.value = response.data.countries; 
        }
    }; 

    const getCities = async(country_id) => {  
        cities.value = [];
        const response = await getcities(country_id); 
        if(response.data !== undefined && response.data.cities !== undefined) {
            cities.value = response.data.cities; 
        }
    };

   

    const formData = ref<KTCreateApp>({   
      
      verifyingdata: false,
      country_text: "",
      country_text2: "",
      job_classification_text: "",
      province_text: "",
      responsedata: {},
      insured_firstName: "",
      insured_middleName: "",
      insured_lastName: "",
      insured_birthday: "",
      username: "",
      password: "",
      cpassword: "",
      sponsorid:  (props.slotdata !== undefined && props.slotdata.spid !== undefined) ? props.slotdata.spid : "",
      uplineid: (props.slotdata !== undefined && props.slotdata.upid !== undefined) ? props.slotdata.upid : "",
      position: (props.slotdata !== undefined && props.slotdata.position !== undefined) ? props.slotdata.position : "",
      insured_mobileNumber: "",
      insured_email: "",
      address_blockAndStreet: "",
      address_nameOfBuilding: "",
      address_unitNumber: "",
      address_city: "",
      address_postalCode: "",
      address_country: "",
      address_country2: "",
      job_classification: "",
      address_province: "",
      beneficiary_firstName: "",
      beneficiary_middleName: "",
      beneficiary_lastName: "",
      beneficiary_birthday: "",
      beneficiary_contact: "",
      beneficiary_relationship: "" ,
      userid: "",
      securitypin: "",
      istncchecked : false
    });



    const isDisabledUPID = props.slotdata !== undefined && props.slotdata.upid !== undefined;

 
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAccountRef.value as HTMLElement
      );   

      console.log("mounted");
      if(props.slotdata !== undefined && props.slotdata.upid !== undefined) {
          formData.value.uplineid = props.slotdata.upid;
          formData.value.sponsorid = props.slotdata.spid;
          formData.value.position = props.slotdata.position;
      }
      httpGetCountries();
      getJobClassifications();
    });

    const createAppSchema = [
      Yup.object({}),  
      
      Yup.object({
        insured_firstName: Yup.string()
          .required()
          .max(50)
          .label("Insured First Name"), 
        insured_lastName: Yup.string()
          .required()
          .max(50)
          .label("Insured Last Name"),
        insured_birthday: Yup.string()
          .required()
          .label("Insured Birth Date"),
        username: Yup.string()
          .required()
          .label("Your Account Username"),
        password: Yup.string()
          .required()
          .label("Your Account Password"),
        cpassword: Yup.string()
          .required()
          .label("Your Account Password Confirmation"), 
        sponsorid: Yup.string()
          .required()
          .max(20)
          .label("Sponsor User ID"),
        uplineid: Yup.string()
          .required()
          .max(20)
          .label("Upline User ID"),
        position: Yup.string()
          .required()
          .label("Position")
      }), 

      Yup.object({  
        insured_mobileNumber: Yup.string()
          .required()
          .max(20)
          .label("Insured Mobile Number"),
        insured_email: Yup.string()
          .required()
          .max(50)
          .label("Insured Email"),
          
        beneficiary_firstName: Yup.string()
          .required()
          .max(50)
          .label("Beneficiary First Name"),
        beneficiary_lastName: Yup.string()
          .required()
          .max(50)
          .label("Beneficiary Last Name"),
        beneficiary_birthday: Yup.string()
          .required()
          .label("Beneficiary Birth Date"),
        beneficiary_relationship: Yup.string()
          .required()
          .label("Beneficiary Relationship"),
        beneficiary_contact: Yup.string()
          .required()
          .max(20)
          .label("Beneficiary Contact#"),
        address_blockAndStreet: Yup.string()
          .required()
          .max(100)
          .label("Your Block and Street address"),
        address_country: Yup.string()
          .required()
          .label("Your Address Country"),
        address_country2: Yup.string()
          .required()
          .label("Your Country of Nationality"),
        job_classification:Yup.string()
          .required()
          .label("Job Classification"),
        address_province: Yup.string()
          .required()
          .label("Your Address Province"),
        address_postalCode:  Yup.string()
          .required()
          .label("Your Address Postal Code"),

      }),

      Yup.object({ 
        userid: Yup.string()
          .required()
          .max(20)
          .label("Activation User ID"),
        securitypin: Yup.string()
          .required()
          .max(20)
          .label("Activation PIN") 


      }) 
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit(values => {
      for (const item in values) {
        // eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(item)) {
          if (values[item]) {
            formData.value[item] = values[item];
          }
        }
      }

      currentStepIndex.value++;
 

      
      console.log("_stepperObj.value : " + _stepperObj.value);
      console.log("TOTAL STEPS : " + totalSteps.value);
      console.log("CURRENT STEP : " + currentStepIndex.value);
      
      if (!_stepperObj.value) {
        return;
      }





      
      if(currentStepIndex.value === 3){ 
        validateForm(formData.value);
      }

      _stepperObj.value.goNext();
    });




    
const validateForm = async (data: any) => { 
      formData.value.verifyingdata = true;
      const response: any =   await confirm_register(data);

      formData.value.verifyingdata = false;
      formData.value.country_text = countries.value.find( e => {
          if(e.country_id == formData.value.address_country) {
           return   e.name;
          }
      }).name;

      formData.value.country_text2 = countries.value.find( e => {
          if(e.country_id == formData.value.address_country2) {
           return   e.name;
          }
      }).name;

      
      formData.value.job_classification_text = job_classification_options_list.value.find( e => {
          var jct_name = "";
          if(e.job_classification_id == formData.value.job_classification) {
             jct_name = e.name;
          }
          return jct_name;
      }).name;

      
      
      formData.value.province_text = cities.value.find( e => {
          if(e.zone_id == formData.value.address_province) {
           return   e.name;
          }
      }).name;

      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
          formData.value.responsedata = response.data;
      }

      

    };

    const formSubmit = async () => {
       
      const response: any =   await save_register(formData.value);
      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
              Swal.fire({
                text: response.data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary"
                }
              }).then(() => {
                window.location.reload();
              });
      }

      
 
    };

    resetForm({
      values: {
        ...formData.value
      }
    });

    return {
      createAccountRef,
      totalSteps,
      previousStep,
      handleStep,
      formSubmit,
      currentStepIndex,
      formData,  
      countries,
      job_classification_options_list,
      getCities,
      cities,
      isDisabledUPID,

    };
  },
  methods: {
     
    async checkBoxValidator(event){
        if (event.target.checked) {
          this.formData.istncchecked = true;
        } else {
          this.formData.istncchecked = false;
        }

        console.log("this.formData.istncchecked : " + this.formData.istncchecked);
      },

    
    
  },
  mounted() { 
    //this.getcountries(); 
   // this.httpGetCountries();
  },
});
</script>
